// Compute the timer display seconds from a timer state object.
export function computeSeconds(timer, now = Date.now()) {
  if (!timer) return 0;
  let elapsed = timer.elapsed || 0;
  if (timer.running && timer.started_at) {
    const started = new Date(timer.started_at).getTime();
    elapsed += (now - started) / 1000;
  }
  if (timer.mode === "countdown") {
    const remaining = (timer.duration || 0) - elapsed;
    return Math.max(0, remaining);
  }
  return elapsed;
}

export function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

// Rich timer parts: main clock + injury/stoppage counting for countdown halves.
export function computeParts(timer, now = Date.now()) {
  if (!timer) return { main: 0, injury: 0, isCountdown: false };
  let elapsed = timer.elapsed || 0;
  if (timer.running && timer.started_at) {
    elapsed += (now - new Date(timer.started_at).getTime()) / 1000;
  }
  if (timer.mode === "countdown") {
    const dur = timer.duration || 0;
    const main = Math.max(0, dur - elapsed);
    const injury = Math.max(0, elapsed - dur);
    return { main, injury, isCountdown: true };
  }
  return { main: elapsed, injury: 0, isCountdown: false };
}
